import { Option as SelectOption } from '@superhi/design/src/components/forms/inputs/SelectInput/SelectInput'

import { API } from 'src/api'

const LEVEL_LANGUAGE: Record<API.ProductCourseDifficultyLevel, string> = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
}

const SUBJECT_LANGUAGE: Record<API.ProductCourseSubject, string> = {
  CODE: 'Code',
  DESIGN: 'Design',
  PROJECT_MANAGEMENT: 'Project Management',
}

export const SUBJECT_OPTIONS: SelectOption<string | undefined>[] = [
  { display: 'Any subject', value: undefined },
  ...Object.values(API.ProductCourseSubject).map((value) => ({
    display: SUBJECT_LANGUAGE[value],
    value,
  })),
]

export const DIFFICULTY_LEVEL_OPTIONS: SelectOption<string | undefined>[] = [
  { display: 'Any level', value: undefined },
  ...Object.values(API.ProductCourseDifficultyLevel).map((value) => ({
    display: LEVEL_LANGUAGE[value],
    value,
  })),
]
